import { createApp } from 'vue'
    import App, { router } from '/drone/src/packages/chargermap/src/pages/chargermap/index.tsx?source=true'
    import { NioApmPlus } from '@nio-fe/nio-apm-plus';
    import { getEnv } from '@nio-wad/hooks';

    const app = createApp(App);
    const start = async () => {
      
      const boots = require.context('/drone/src/packages/chargermap/src/pages/chargermap/boot', false, /.ts$/);
      const bootKeys =  boots.keys();
      for (let i = 0; i < bootKeys.length; i++) {
        await boots(bootKeys[i]).default({app})
      }
      
      app.use(router).mount('#app')
    }
    start();
  